(function () {
  function getWidget() {
    return document.getElementById("auction_app") ||
      document.querySelector("#auction-today-slot div[id*='auction']") ||
      document.querySelector("#auction-today-slot .auction-app, #auction-today-slot .auction_app");
  }

  function findEndTime(widget) {
    const rows = widget.querySelectorAll("tr");
    for (const tr of rows) {
      const tds = tr.querySelectorAll("td");
      if (tds.length >= 2) {
        const label = (tds[0].innerText || "").trim().toLowerCase();
        if (label.includes("end time")) return (tds[1].innerText || "").trim();
      }
    }
    return null;
  }

  function parseDate(str) {
    let d = new Date(str);
    if (!isNaN(d.getTime())) return d;
    d = new Date(str.replace(",", ""));
    if (!isNaN(d.getTime())) return d;
    return null;
  }

  function fmt(ms) {
    const s = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(s / 86400);
    const hrs = Math.floor((s % 86400) / 3600);
    const mins = Math.floor((s % 3600) / 60);
    const secs = s % 60;
    return `${days}d ${hrs}h ${mins}m ${secs}s`;
  }

  function hideBlankTimerRow(widget) {
    const trs = Array.from(widget.querySelectorAll("tr"));
    const idx = trs.findIndex(tr => (tr.innerText || "").toLowerCase().includes("time remaining"));
    if (idx >= 0 && trs[idx + 1]) {
      const next = trs[idx + 1];
      if (!/\d/.test(next.innerText || "") && next.getBoundingClientRect().height > 60) {
        next.style.display = "none";
      }
    }
  }

  function init() {
    const widget = getWidget();
    if (!widget) return;

    const endText = findEndTime(widget);
    if (!endText) return;

    const endDate = parseDate(endText);
    if (!endDate) return;

    hideBlankTimerRow(widget);

    const box = document.getElementById("ups-auction-countdown");
    const out = document.getElementById("ups-auction-countdown-text");
    if (!box || !out) return;

    box.style.display = "block";

    const tick = () => {
      out.textContent = fmt(endDate.getTime() - Date.now());
    };
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
